import { CustomAsyncPipe } from '@/shared/utils/angular-sdk';
import { Pipe, type PipeTransform, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { ProfileProvider } from '../providers/profile/profile.provider';

@Pipe({
    name: 'hasRight',
    pure: false
})
export class HasRightPipe extends CustomAsyncPipe<string, boolean> implements PipeTransform {
    private _profileProvider = inject(ProfileProvider);

    transformInputIntoObservableOfOutput(right: string): Observable<boolean> {
        return this._profileProvider.hasRight$(right);
    }
}
